module.exports = __webpack_public_path__ + "img/icon4.b2e2e621.svg";